import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService } from './services/locale.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor (
    localeService: LocaleService,
    translateService: TranslateService
  ) {
    let lang = translateService.getBrowserLang();
    if (lang !== 'es') {
      lang = 'en';
    }
    translateService.setDefaultLang(lang);
    translateService.use(lang);
  }

  ngOnInit () {}
}
